import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { CaretDown, Rocket, Crown, GlobeHemisphereEast, Handshake, Tag } from "@phosphor-icons/react";
import { PLAN_LINKS } from "../lib/plansConfig";

const ICONS = { Rocket, Crown, GlobeHemisphereEast, Handshake };

export function PlansMenu() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const timer = useRef(null);
  const isActive = location.pathname.startsWith("/plans");

  const openNow = () => { clearTimeout(timer.current); setOpen(true); };
  const closeSoon = () => { timer.current = setTimeout(() => setOpen(false), 120); };
  useEffect(() => () => clearTimeout(timer.current), []);

  return (
    <div className="relative h-14 flex items-center" onMouseEnter={openNow} onMouseLeave={closeSoon} data-testid="plans-menu">
      <button
        type="button"
        data-testid="plans-menu-trigger"
        className={`px-2.5 h-14 flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.12em] border-b-2 transition-colors duration-150 ${
          isActive ? "border-[#6043EF] text-[#6043EF]" : "border-transparent text-[#52525B] hover:text-[#09090B] hover:border-zinc-300"
        }`}
      >
        <Tag size={14} weight={isActive ? "bold" : "regular"} />
        Plans
        <CaretDown size={11} weight="bold" className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div
          className="absolute left-0 top-full z-50 w-[380px] max-w-[92vw] bg-white border border-zinc-200 shadow-[0_18px_50px_-12px_rgba(0,0,0,0.25)] rounded-b-xl overflow-hidden animate-fade-in"
          data-testid="plans-menu-panel"
        >
          <div className="px-4 py-2.5 bg-gradient-to-r from-[#F7F5FF] to-[#EFFdF6] border-b border-zinc-100">
            <span className="text-[10px] font-black uppercase tracking-[0.2em] text-[#6043EF]">Choose your path to a seat</span>
          </div>
          {PLAN_LINKS.map((p) => {
            const Icon = ICONS[p.icon];
            return (
              <Link
                key={p.id}
                to={p.to}
                onClick={() => setOpen(false)}
                data-testid={`plans-menu-link-${p.id}`}
                className="flex items-start gap-3 px-4 py-3 hover:bg-zinc-50 transition-colors border-b border-zinc-50 last:border-0 group"
              >
                <span className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0" style={{ backgroundColor: `${p.accent}1A` }}>
                  <Icon size={18} weight="fill" style={{ color: p.accent }} />
                </span>
                <span className="min-w-0">
                  <span className="block text-sm font-bold text-[#09090B] group-hover:text-[#6043EF] transition-colors">{p.label}</span>
                  <span className="block text-xs text-zinc-500 mt-0.5">{p.tagline}</span>
                </span>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
